export default __webpack_public_path__ + "static/media/shards-dashboards-logo.9262a9e4.svg";